
import {applyMixin} from "@/mixins/applyMixin";
import {getProAppVersion} from "~/api/document";
import androidCodeImg from "@/assets/imgs/smproapp/android-code.png";
import androidCodeTestImg from "@/assets/imgs/smproapp/android-test-code.png";
import androidCodePreImg from '@/assets/imgs/smproapp/android-pre-code.png'
import {pluginUrl} from "@/api/api-list";
import {statistics} from "@/api/statistics";
export default {
  name: "index",

  mixins: [applyMixin],
  data() {
    return {
      androidCode: process.env.VUE_APP_TITLE !== 'test' ? process.env.VUE_APP_TITLE === 'pre' ? androidCodePreImg : androidCodeImg : androidCodeTestImg,
      iframeUrl: pluginUrl + "/intranet#/" + "?t=" + new Date().getTime(),
      channel: 'web',
      iframeShow:true, // iframe显示
      breadcrumbList: [
        {
          title: '解决方案',
          path: null
        },
        {
          title: '内网测速',
          path: null
        }
      ],
      intranetSystemList: [
        {title: '测速客户端'},
        {title: '后台管理系统'},
        {title: '测速节点服务器',title2:'可选额外付费使用<br/>测速网线上节点'},
        {title: '测速节点调度系统'},
        {title: '测速节点监控系统'},
      ],
      clientList: [
        {title: '仅需购买网维助手APP账号'},
        {title: '方便快捷，操作简易'},
        {title: '一键部署，一键测试'},
        {title: '入户测试，宽带装维'},
        {title: '多终端支持'}
      ],
      usageScenario: [
        {info1: '支持多种终端', info2: '电脑、平板、手机'},
        {info1: '校园网络下', info2: '内网测速'},
        {info1: '办公网络下', info2: '内网测速'},
        {info1: '分布在不同城市/', info2: '地区内网系统'}
      ],
      classify: 1,
      bannerOptions: {
        slidesPerView: 1,// 可显示的数量
        slidesPerGroup: 1,//移动个数
        autoplay: {// 自动滑动
          delay: 6000, //6秒切换一次
          disableOnInteraction: false
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        loop: true, // 循环模式选项
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      },
      swiperList: [
        {img: require('@/assets/imgs/intranet/introduce-1.png'), id: 1},
        {img: require('@/assets/imgs/intranet/introduce-2.png'), id: 2},
        {img: require('@/assets/imgs/intranet/introduce-3.png'), id: 3}
      ],
      downloadActive: '',
      downloadList: [
        {
          title: 'Android',
          icon: require('@/assets/imgs/smproapp/Android.svg'),
          activeIcon: require('@/assets/imgs/smproapp/Android-active.svg'),
          type: 1,
          href: null,
        },
        {
          title: 'Windows',
          icon: require('@/assets/imgs/smproapp/Windows.svg'),
          activeIcon: require('@/assets/imgs/smproapp/Windows-active.svg'),
          type: 3,
          href: null,
        },
        // {
        //   title: 'Windows 32位',
        //   icon: require('@/assets/imgs/smproapp/Windows.svg'),
        //   activeIcon: require('@/assets/imgs/smproapp/Windows-active.svg'),
        //   type: 2,
        //   href: null,
        // },
        {
          title: 'macOS',
          icon: require('@/assets/imgs/smproapp/macOS.svg'),
          activeIcon: require('@/assets/imgs/smproapp/macOS-active.svg'),
          type: 4,
          href: null,
        }
      ],
      androidDownloadUrl: null,
      win64DownloadUrl: null,
      win32DownloadUrl: null,
      macDownloadUrl: null,
      iOSDownloadUrl:null,
      androidIcon: require('@/assets/imgs/smproapp/Android.svg'),
      androidActiveIcon: require('@/assets/imgs/smproapp/Android-active.svg'),
      windowsIcon: require('@/assets/imgs/smproapp/Windows.svg'),
      windowsActiveIcon: require('@/assets/imgs/smproapp/Windows-active.svg'),
      macIcon: require('@/assets/imgs/smproapp/macOS.svg'),
      macActiveIcon: require('@/assets/imgs/smproapp/macOS-active.svg'),
      iOSIcon: require('@/assets/imgs/smproapp/iOS.svg'),
      iOSActiveIcon: require('@/assets/imgs/smproapp/iOS-active.svg'),
      willIcon: require('@/assets/imgs/smproapp/will-icon.svg'),
    };
  },
  methods: {
    changeChannel(channel) {
      this.channel = channel;
      this.iframeShow = false;
      setTimeout(()=>{
        this.iframeShow = true;
      })
    },
    /**
     * 请求专业版的信息
     * */
    queryProAppVersion() {
      this.$store.commit('LOADING_STATE', true);
      Promise.all([this.judgeDownloadUrl('Android'), this.judgeDownloadUrl('win64'),
        this.judgeDownloadUrl('iOS'), this.judgeDownloadUrl('mac')]).finally(res => {
        this.$store.commit('LOADING_STATE', false);
      })
    },
    /**
     * 对数据进行判断
     * @param {String} type : Android,win64,win32,mac,ios
     * */
    judgeDownloadUrl(type) {
      return getProAppVersion({type}).then(res => {
        if (!res.data.downloadUrl) {
          return
        }
        let typeMap = new Map([
          [
            'win64',
            () => {
              this.win64DownloadUrl = res.data.downloadUrl
            }
          ],
          [
            'mac',
            () => {
              this.macDownloadUrl = res.data.downloadUrl
            }
          ],
          [
            'Android',
            () => {
              this.androidDownloadUrl = res.data.downloadUrl
            }
          ],
          [
            'iOS',
            () => {
              this.iOSDownloadUrl = res.data.downloadUrl
            }
          ],
          [
            'win32',
            () => {
              this.win32DownloadUrl = res.data.downloadUrl
            }
          ],

        ])
        typeMap.get(type)()
      })
    },
    selectClick (name) {
      statistics({
        position: name,
        type: 'click'
      })
    }
  },
  created() {
    this.queryProAppVersion();
  },
};
